import appLoans from "../../views/appSettings/loans.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "loans";
  const params = ["page", "limit"];

  $stateProvider.state("loans", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appLoans,
      },
    },
    reloadOnSearch: false,
    data: { title: "Loans" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/loans/loans.urls.js